import React from 'react';
import AreaLandingPage, { AreaConfig } from '../components/AreaLandingPage';

const goregaon: AreaConfig = {
  name: 'Goregaon',
  slug: 'goregaon',
  tagline: 'Doorstep Mobile Repair in Goregaon, Mumbai',
  description:
    'Screen cracked? Battery dead? Minto sends a certified technician to your home or office in Goregaon East or West — NESCO, Film City area, Aarey Colony — repairs done in under an hour, no travel needed.',
  localities: [
    'Goregaon East', 'Goregaon West', 'NESCO', 'Film City', 'Aarey Colony',
    'MHB Colony', 'Bangur Nagar', 'Jawahar Nagar', 'Jogeshwari East',
    'Jogeshwari West', 'Link Road', 'S.V. Road', 'Malad adjacent',
  ],
  zones: [
    {
      name: 'Goregaon East — NESCO & Film City',
      line: 'Western Line',
      station: 'Goregaon East Station',
      localities: ['NESCO', 'Film City', 'Goregaon East', 'MHB Colony', 'Jawahar Nagar', 'Aarey Road', 'Hub Mall area'],
      desc: 'Covering Goregaon East including the tech parks at NESCO and Film City zone. Office and home repairs both available.',
    },
    {
      name: 'Goregaon West — Bangur Nagar & S.V. Road',
      line: 'Western Line',
      station: 'Goregaon West Station',
      localities: ['Goregaon West', 'Bangur Nagar', 'S.V. Road', 'Link Road', 'Oshiwara Market', 'Andheri-Goregaon border'],
      desc: 'Residential Goregaon West covered with fast doorstep service. Our technicians reach Bangur Nagar and S.V. Road areas in under 60 minutes.',
    },
    {
      name: 'Jogeshwari',
      line: 'Western Line',
      station: 'Jogeshwari Station',
      localities: ['Jogeshwari East', 'Jogeshwari West', 'Aarey Colony', 'Film City Road', 'Pathanwadi'],
      desc: 'Jogeshwari sits between Andheri and Goregaon and is fully covered by our Goregaon service team.',
    },
  ],
  seo: {
    title: 'Mobile Repair in Goregaon | Doorstep Phone Repair | Minto',
    description:
      'Doorstep mobile repair in Goregaon East & West, NESCO, Film City, Jogeshwari, Mumbai. Screen replacement, battery repair. Certified technicians, 90-day warranty. Book now!',
    keywords:
      'mobile repair Goregaon, phone repair Goregaon, screen repair Goregaon, battery replacement Goregaon, iPhone repair Goregaon, Samsung repair Goregaon, NESCO phone repair, Film City mobile repair, Jogeshwari mobile repair, Bangur Nagar phone repair, doorstep repair Goregaon',
  },
  faqs: [
    {
      q: 'Do you offer mobile repair in Goregaon East?',
      a: 'Yes, we cover all of Goregaon East including NESCO, Film City, MHB Colony, and Jawahar Nagar.',
    },
    {
      q: 'Can you repair my phone at my office near NESCO?',
      a: 'Absolutely. We regularly service offices in NESCO and nearby IT parks in Goregaon East.',
    },
    {
      q: 'Do you also cover Jogeshwari near Goregaon?',
      a: 'Yes, Jogeshwari East and West are covered under our Goregaon service zone.',
    },
    {
      q: 'How much does screen repair cost in Goregaon?',
      a: 'Screen repair starts from ₹999 depending on your device. Check the exact price on our booking page.',
    },
    {
      q: 'Is same-day repair available in Goregaon?',
      a: 'Yes, same-day service is available. Book before 6 PM for a same-day visit.',
    },
  ],
};

const GoregaonPage: React.FC = () => <AreaLandingPage area={goregaon} />;
export default GoregaonPage;
